export const gitCommit = 'c4aebcf8'
